import { useOutletContext } from 'react-router-dom';
import InvoiceRemindersBoard from 'components/invoiceReminders/InvoiceRemindersBoard';

const RemindersContent = () => {
  const {
    remindersSummary,
    reminderFilters,
    onClearReminderFilters,
    remindersRefreshKey,
  } = useOutletContext();

  return (
    <InvoiceRemindersBoard
      summary={remindersSummary?.summary}
      onReloadSummary={remindersSummary?.reload}
      filters={reminderFilters}
      onClearFilters={onClearReminderFilters}
      refreshKey={remindersRefreshKey}
    />
  );
};

export default RemindersContent;
